var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"custom-class feather feather-check",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"20","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20 6 9 17l-5-5"}})])
}
var staticRenderFns = []

export default { render: render }